import { createSlice } from "@reduxjs/toolkit";

import { getPromotionalBanner } from "../../reduxApi/admin/PromotionalBannerApi";

const PromotionalBannerSlice = createSlice({
  name: "PromotionalBanner",
  initialState: {
    status: "idle",
    promotionalBanner: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPromotionalBanner.fulfilled, (state, action) => {
      // console.log("API Response:", action.payload.data);
      state.status = "fulfilled";
      // state.products = action.payload.products;
      state.promotionalBanner = action.payload.data;
      console.log("state.PromotionalBannerSlice", state.promotionalBanner);
    });
  },
});

export default PromotionalBannerSlice.reducer;
